
import { mixins, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import WithModel from '../mixins/withModel'

@Options({
    components: {
    }
})
export default class inputTime extends mixins(WithModel) {

    @Prop({
        default: 0
    }) tabIndex;

    @Prop({
        default: false
    }) readonly: boolean;

}
